module.exports = __webpack_public_path__ + "img/selectedReportSilde.71d9da9a.png";